export default function AuthService($http, localStorageService) {

  this.getExamObjByName = function(name) {
    var examArrayFromService = [{'examName': 'Exam1', 'examId': 'exam1skol1'},{'examName': 'Exam2', 'examId': 'exam1skol2'},
                                {'examName': 'Exam3', 'examId': 'exam3skol1'},{'examName': 'Exam4', 'examId': 'exam4skol2'},
                                {'examName': 'Exam5', 'examId': 'exam5skol1'},{'examName': 'Exam6', 'examId': 'exam6skol2'},
                                {'examName': 'Exam7', 'examId': 'exam7skol1'},{'examName': 'Exam8', 'examId': 'exam8skol2'},
                                {'examName': 'Exam9', 'examId': 'exam9skol1'},{'examName': 'Exam10', 'examId': 'exam10skol2'},
                                {'examName': 'Exam11', 'examId': 'exam11skol1'},{'examName': 'Exam12', 'examId': 'exam12skol2'},
                                {'examName': 'Exam13', 'examId': 'exam13skol1'},{'examName': 'Exam14', 'examId': 'exam14skol2'},
                                {'examName': 'Exam15', 'examId': 'exam15skol1'},{'examName': 'Exam16', 'examId': 'exam16skol2'},
                                {'examName': 'Exam17', 'examId': 'exam17skol1'},{'examName': 'Exam18', 'examId': 'exam18skol2'},
                                {'examName': 'Exam19', 'examId': 'exam19skol1'},{'examName': 'Exam20', 'examId': 'exam20skol2'},
                                {'examName': 'Exam21', 'examId': 'exam21skol1'},{'examName': 'Exam22', 'examId': 'exam22skol2'},
                                {'examName': 'Exam23', 'examId': 'exam23skol1'},{'examName': 'Exam24', 'examId': 'exam24skol2'}];
    var objectToReturn = {};
    for(var i=0; i<examArrayFromService.length;i++){
      if(examArrayFromService[i].examName == name){
        objectToReturn = examArrayFromService[i];
      }
    }
    return objectToReturn;
  };
}


/** WEBPACK FOOTER **
 ** ./src/olr-common/GetService.js
 **/